import React, { useEffect } from "react";
import PropTypes from "prop-types";

window.metrikaQueue = [];

export function reachGoal(target, params, callback) {
    if (window.yaCounter45661026) {
        console.log("reachGoal", target, params, callback);
        window.yaCounter45661026.reachGoal(target, params, callback);
    } else {
        console.log("reachGoal.queue", target, params, callback);
        window.metrikaQueue.push([target, params, callback]);
    }
}

const YaMetrika = ({ id }) => {
    useEffect(() => {
        document.addEventListener(`yacounter${id}inited`, () => {
            console.log("metrika is ready");
            while (window.metrikaQueue.length) {
                const [target, params, callback] = window.metrikaQueue.pop();
                reachGoal(target, params, callback);
            }
        });

        (function(d, w, c) {
            (w[c] = w[c] || []).push(function() {
                try {
                    w.yaCounter45661026 = new Ya.Metrika2({
                        id,
                        clickmap: true,
                        trackLinks: true,
                        accurateTrackBounce: true,
                        webvisor: true,
                        triggerEvent: true
                    });
                } catch (e) {}
            });
            var n = d.getElementsByTagName("script")[0],
                s = d.createElement("script"),
                f = function() {
                    n.parentNode.insertBefore(s, n);
                };
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://mc.yandex.ru/metrika/tag.js";
            if (w.opera == "[object Opera]") {
                d.addEventListener("DOMContentLoaded", f, false);
            } else {
                f();
            }
        })(document, window, "yandex_metrika_callbacks2");
    }, [id]);

    return null;
};

YaMetrika.propTypes = {
    id: PropTypes.number.isRequired
};

export default YaMetrika;
